(function () {
  var root = document.querySelector('[data-cf-aide]');
  if (!root) return;
  var btn = root.querySelector('[data-cf-aide-open]');
  var panel = root.querySelector('.cf-aide__panel');
  var log = root.querySelector('[data-cf-aide-log]');
  var closeBtn = root.querySelector('[data-cf-aide-close]');
  var answers = root.querySelector('[data-cf-aide-answers]');

  function open() {
    panel.hidden = false; root.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true');
    closeBtn.focus();
  }
  function close() {
    panel.hidden = true; root.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false');
    btn.focus();
  }
  btn.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });

  panel.addEventListener('click', function (e) {
    var chip = e.target.closest('.cf-aide__chip');
    if (!chip) return;
    var a = answers.content.querySelector('[data-a="' + chip.dataset.q + '"]');
    if (!a) return;
    var me = document.createElement('p');
    me.className = 'cf-aide__msg cf-aide__msg--me';
    me.textContent = chip.textContent;
    var shop = document.createElement('div');
    shop.className = 'cf-aide__msg cf-aide__msg--shop';
    shop.innerHTML = a.innerHTML;
    log.appendChild(me); log.appendChild(shop);
    log.scrollTop = log.scrollHeight;
  });

  // Fiche produit : la bulle s'efface tant que le vrai bouton d'ajout au panier est visible.
  var cta = document.querySelector('.cf-pdp-buybox .add-to-cart-button');
  if (cta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      root.classList.toggle('is-hidden-by-cta', en[0].isIntersecting);
    }).observe(cta);
  }
})();
